import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { errorAlert, successAlert } from "../components/utils/messages";
import { forgotPassword } from "../redux/actions/user";

const ForgotPassword = () => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (!email) {
      errorAlert("Por favor ingresa tu correo electrónico");
      return;
    }

    setLoading(true);
    try {
      const success = await forgotPassword(email);
      if (success) {
        successAlert(
          "Si el correo existe, recibirás un enlace de recuperación"
        );
        // Redirigir al login después de 2 segundos
        setTimeout(() => {
          history.push("/login");
        }, 2000);
      } else {
        errorAlert("Error al procesar la solicitud");
      }
    } catch (error) {
      errorAlert("Error al procesar la solicitud");
    } finally {
      setLoading(false);
    }
  }, [email, history]);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleBackToLogin = () => {
    history.push("/login");
  };

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="6">
            <CCard className="p-4">
              <CCardBody>
                <CForm>
                  <h1>Recuperar Contraseña</h1>
                  <p className="text-muted">
                    Ingresa tu correo electrónico y te enviaremos un enlace para
                    restablecer tu contraseña
                  </p>
                  <CInputGroup className="mb-3">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <CIcon name="cil-envelope-closed" />
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CInput
                      type="email"
                      placeholder="Correo Electrónico"
                      autoComplete="email"
                      onChange={handleEmailChange}
                      value={email}
                      disabled={loading}
                    />
                  </CInputGroup>
                  <CRow>
                    <CCol xs="6">
                      <CButton
                        color="primary"
                        className="px-4"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {loading ? "Enviando..." : "Enviar"}
                      </CButton>
                    </CCol>
                    <CCol xs="6" className="text-right">
                      <CButton
                        color="link"
                        className="px-0"
                        onClick={handleBackToLogin}
                        disabled={loading}
                      >
                        Volver a inciar sesión
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default ForgotPassword;
